/**
 * Hack for iOS12 page scroll
 * https://developers.weixin.qq.com/community/develop/doc/00044ae90742f8c82fb78fcae56800
 */
import { isIOS as checkIsIOS } from '../validate/system';
import { getRootScrollTop, setRootScrollTop } from './scroll';
var isIOS = checkIsIOS();
/* istanbul ignore next */

export function resetScroll() {
  if (isIOS) {
    setRootScrollTop(getRootScrollTop());
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/dom/reset-scroll.js
// module id = 228
// module chunks = 7